// @flow
import React, { Component } from 'react';
import JsonScript from 'app/common/react/components/head/JsonScript';
import PropTypes from 'prop-types';

// $FlowFixMe
export class ProfileSnippet extends Component {
  getCurrentUrl() {
    return this.context.origin + this.context.fullPath;
  }

  generateJson() {
    const { user } = this.props;

    const userJson = {
      '@context': 'http://schema.org/',
      '@type': 'Person',
      name: user.full_name || user.username,
      mainEntityofPage: {
        '@type': 'ProfilePage',
        '@id': this.getCurrentUrl(),
      },
    };

    // $FlowFixMe
    Object.assign(
      userJson,
      user.image_xlarge_url && {
        image: {
          '@type': 'ImageObject',
          contentUrl: user.image_xlarge_url,
        },
      },
      user.location && {
        address: {
          '@type': 'PostalAddress',
          addressLocality: user.location,
        },
      },
      user.about && { description: user.about },
      user.domain_url && { url: user.domain_url },
    );

    return userJson;
  }

  // https://developers.google.com/search/docs/guides/mark-up-content#content_types
  render() {
    const { isAuthenticated } = this.context;

    if (isAuthenticated) {
      return null;
    }

    return <JsonScript type="application/ld+json" value={this.generateJson()} />;
  }
}

ProfileSnippet.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string,
    full_name: PropTypes.string.isRequired,
    location: PropTypes.string,
    address: PropTypes.string,
    about: PropTypes.string,
    domain_url: PropTypes.string,
    image_xlarge_url: PropTypes.string,
  }).isRequired,
};

ProfileSnippet.contextTypes = {
  fullPath: PropTypes.string.isRequired,
  origin: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

export default ProfileSnippet;
